import { FormattedMessage } from 'react-intl';
import bemify from 'bemify-js';
import React, { ReactNode } from 'react';

import { Link } from '@zapier/design-system';
import { getGuideStepIndexByKey } from 'app/cli-guide/utils';
import { DOCUMENTATION_URL, GUIDE_STEPS } from 'app/cli-guide/constants';

import './StepContent.scss';
import WizardFooter from '../WizardFooter';

const bem = bemify('step-content');

type StepItem = {
  key: string;
  renderContent: () => ReactNode;
  nextButtonText: string;
};

type Props = {
  onClickBack: () => void;
  onClickNext: () => void;
  step: StepItem;
};

const defaultProps = { active: false, completed: false };

const StepContent = (props: Props) => {
  const { step, onClickBack, onClickNext } = props;

  const currentIndex = getGuideStepIndexByKey(step.key);
  const isFirstStep = currentIndex === 0;
  const isLastStep = currentIndex === GUIDE_STEPS.length + 1;
  const nextStep = isLastStep ? null : GUIDE_STEPS[currentIndex + 1];
  const nextHref = nextStep?.path ?? DOCUMENTATION_URL;

  return (
    <div className={bem()}>
      <div className={bem('__main')}>
        <section className={bem('__wrapper')}>{step.renderContent()}</section>
      </div>
      <WizardFooter>
        {!isFirstStep && (
          <span>
            <Link
              href={GUIDE_STEPS[currentIndex - 1].path}
              onPress={() => onClickBack()}
              variant="secondary"
            >
              <FormattedMessage defaultMessage="Back" id="buttons-back" />
            </Link>
          </span>
        )}
        <span>
          <Link
            href={nextHref}
            onPress={() => onClickNext()}
            variant="secondary"
          >
            {step.nextButtonText}
          </Link>
        </span>
      </WizardFooter>
    </div>
  );
};

StepContent.defaultProps = defaultProps;

export default StepContent;
